import styled from 'styled-components'

import { ClinTheme } from '../../ClinTheme'
import { mediaQueryDown } from '../../utils/mediaQuery'

// Keep long notifications readable without spanning the whole page.
export const PAGE_TOAST_WIDTH = 560
export const PAGE_TOAST_MOBILE_BREAKPOINT = 599
const GUTTER = ClinTheme.space[3]

/** A page that draws its own header (checkout) renders an anchor with this id under it. */
export const PAGE_TOAST_ANCHOR_ID = 'page-toast-anchor'

/** Notifications reserve space below the header instead of covering controls. */
export const pageToastMobilePlacement = {
  marginLeft: GUTTER,
  marginRight: GUTTER,
  width: `calc(100% - ${GUTTER * 2}px)`,
  maxWidth: 'none'
}

export const pageToastPlacement = {
  position: 'relative' as const,
  boxSizing: 'border-box' as const,
  marginLeft: 'auto',
  marginRight: `max(${GUTTER}px, calc((100% - ${ClinTheme.containerWidths[3]}px) / 2 + ${GUTTER}px))`,
  marginTop: GUTTER,
  width: PAGE_TOAST_WIDTH,
  maxWidth: `calc(100% - ${GUTTER * 2}px)`,
  [mediaQueryDown(PAGE_TOAST_MOBILE_BREAKPOINT)]: pageToastMobilePlacement
}

/** Empty anchors take no space; a notification expands the page naturally. */
export const StyledPageToastAnchor = styled.div({
  position: 'relative',
  width: '100%',
  display: 'flow-root'
})

export const StyledPageToast = styled.div<{
  backgroundColor: string
  $fullWidth?: boolean
}>(({ backgroundColor, $fullWidth }) => ({
  ...pageToastPlacement,
  display: 'flex',
  alignItems: 'flex-start',
  gap: ClinTheme.space[3],
  borderRadius: ClinTheme.radii[3],
  boxShadow: $fullWidth ? 'none' : ClinTheme.shadows[2],
  backgroundColor,
  padding: `${ClinTheme.space[3]}px ${ClinTheme.space[4]}px`,
  ...($fullWidth && {
    width: `calc(100% - ${GUTTER * 2}px)`,
    maxWidth: ClinTheme.containerWidths[3] - GUTTER * 2,
    marginLeft: 'auto',
    marginRight: 'auto',
    [mediaQueryDown(PAGE_TOAST_MOBILE_BREAKPOINT)]: {
      marginLeft: GUTTER,
      marginRight: GUTTER,
      width: `calc(100% - ${GUTTER * 2}px)`
    }
  })
}))

export const StyledPageToastText = styled.div({
  flex: '1 1 0',
  minWidth: 0,
  overflowWrap: 'anywhere',
  '& > div + div': { marginTop: ClinTheme.space[1] }
})

/** A link-style action under the message, e.g. "Open screening forms". */
export const StyledPageToastAction = styled.button({
  display: 'block',
  padding: 0,
  backgroundColor: 'transparent',
  border: 'none',
  color: 'inherit',
  font: 'inherit',
  fontWeight: ClinTheme.fontWeights.bold,
  textDecoration: 'underline',
  cursor: 'pointer'
})

export const StyledPageToastClose = styled.button({
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: ClinTheme.space[1],
  backgroundColor: 'transparent',
  border: 'none',
  cursor: 'pointer'
})
